// frontend/src/utils/mediaUtils.js

export const isMediaFileUrl = (url) => {
    if (!url) return false;
    // Check specifically for video extensions
    return /\.(mp4|webm|mov|avi|mkv|m4v)(\?.*)?$/i.test(url);
};

export const isImageFileUrl = (url) => {
    if (!url) return false;
    // Check specifically for image extensions
    return /\.(jpg|jpeg|png|gif|webp|bmp|svg|tiff)(\?.*)?$/i.test(url);
};

export const isAudioFileUrl = (url) => {
    if (!url) return false;
    // Check specifically for audio extensions
    return /\.(mp3|wav|ogg|aac|flac|m4a)(\?.*)?$/i.test(url);
};

export const validateBlobType = (contentType, blobType, t) => {
    // 1. Video Mode checks
    if (contentType === 'video' && blobType.startsWith('image/')) {
        throw new Error(t("contentInput.errors.fetchMismatchVideoExpected"));
    }

    // 2. Image Mode checks
    if (contentType === 'image' && blobType.startsWith('video/')) {
        throw new Error(t("contentInput.errors.fetchMismatchImageExpected"));
    }

    // 3. Text Mode checks (Ensure we didn't download a binary media file)
    if (contentType === 'text') {
        if (blobType.startsWith('image/') || blobType.startsWith('video/') || blobType.startsWith('audio/')) {
            throw new Error(t("contentInput.errors.fetchMismatchTextExpected"));
        }
    }
};

export const validateUrlExtension = (contentType, url, t) => {
    const isVideo = isMediaFileUrl(url);
    const isImage = isImageFileUrl(url);
    const isAudio = isAudioFileUrl(url);

    // 1. If it looks like an Image, but Content Type is NOT Image -> Error
    // (This protects Video, Audio, and Text inputs)
    if (isImage && contentType !== 'image') {
        throw new Error(t("contentInput.errors.imageForImageOnly"));
    }

    // 2. If it looks like a Video, but Content Type is NOT Video -> Error
    // (This protects Image, Audio, and Text inputs)
    if (isVideo && contentType !== 'video') {
        throw new Error(t("contentInput.errors.videoForVideoOnly"));
    }

    // 3. If it looks like Audio, but Content Type is NOT Audio -> Error
    // (This protects Image, Video, and Text inputs)
    if (isAudio && contentType !== 'audio') {
        throw new Error(t("contentInput.errors.audioForAudioOnly"));
    }
};